import { render, staticRenderFns } from "./TipoUsuarioPerfilGrid.vue?vue&type=template&id=42869b74&scoped=true&"
import script from "./TipoUsuarioPerfilGrid.vue?vue&type=script&lang=js&"
export * from "./TipoUsuarioPerfilGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42869b74",
  null
  
)

/* custom blocks */
import block0 from "./TipoUsuarioPerfilGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports